'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragDropContext = require('./components/DragDropContext.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragDropContext).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-drag-drop/lib/components/drag-drop-context/index.js
// module id = 1183
// module chunks = 0